
export default {
    root: {
        background: '{content.background}',
        borderRadius: '{border.radius.lg}',
        color: '{content.color}',
        shadow: '0 .125rem .25rem rgba(0,0,0,.075)'
    },
    body: {
        padding: '1rem',
        gap: '0.75rem'
    },
    header: {
        padding: '.5rem',
    },
    caption: {
        gap: '0.5rem'
    },
    title: {
        fontSize: '1.25rem',
        fontWeight: '500',
        marginBottom: ".4rem"
    },
    subtitle: {
        color: '{text.muted.color}'
    }
};
